var _MultiTargetLogRecordProcessor_instances, _MultiTargetLogRecordProcessor_config, _MultiTargetLogRecordProcessor_isShutdown, _MultiTargetLogRecordProcessor_queues, _MultiTargetLogRecordProcessor_export, _MultiTargetLogRecordProcessor_pushToQueue, _MultiTargetLogRecordProcessor_flushAll;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import { SeverityNumber } from '@opentelemetry/api-logs';
import { LogQueue } from './log-queue';
import { exportCommon, getCachedLogProcessorDefaults } from './utils';
export class MultiTargetLogRecordProcessor {
    constructor(config = {}) {
        _MultiTargetLogRecordProcessor_instances.add(this);
        _MultiTargetLogRecordProcessor_config.set(this, void 0);
        _MultiTargetLogRecordProcessor_isShutdown.set(this, false);
        _MultiTargetLogRecordProcessor_queues.set(this, void 0);
        __classPrivateFieldSet(this, _MultiTargetLogRecordProcessor_config, { ...getCachedLogProcessorDefaults(), ...config }, "f");
        __classPrivateFieldSet(this, _MultiTargetLogRecordProcessor_queues, {}, "f");
        Object.keys(__classPrivateFieldGet(this, _MultiTargetLogRecordProcessor_config, "f").exporters).forEach((exporterKey) => {
            __classPrivateFieldGet(this, _MultiTargetLogRecordProcessor_queues, "f")[exporterKey] = new LogQueue({
                exporter: __classPrivateFieldGet(this, _MultiTargetLogRecordProcessor_config, "f").exporters[exporterKey],
                flushConfig: __classPrivateFieldGet(this, _MultiTargetLogRecordProcessor_config, "f").flushConfig,
                errorHandler: __classPrivateFieldGet(this, _MultiTargetLogRecordProcessor_config, "f").errorHandler,
            });
        });
    }
    setExporters(exporters, exporterTargets, flushQueues = false) {
        if (__classPrivateFieldGet(this, _MultiTargetLogRecordProcessor_isShutdown, "f")) {
            return Promise.reject(new Error('Processor has been shutdown'));
        }
        const drainPromise = flushQueues
            ? Promise.all(Object.values(__classPrivateFieldGet(this, _MultiTargetLogRecordProcessor_queues, "f")).map(queue => queue.shutdown()))
            : Promise.resolve();
        return drainPromise.then(() => {
            __classPrivateFieldGet(this, _MultiTargetLogRecordProcessor_config, "f").exporters = exporters;
            __classPrivateFieldGet(this, _MultiTargetLogRecordProcessor_config, "f").exporterTargets = exporterTargets;
            __classPrivateFieldSet(this, _MultiTargetLogRecordProcessor_queues, {}, "f");
            Object.keys(exporters).forEach((exporterKey) => {
                __classPrivateFieldGet(this, _MultiTargetLogRecordProcessor_queues, "f")[exporterKey] = new LogQueue({
                    exporter: exporters[exporterKey],
                    flushConfig: __classPrivateFieldGet(this, _MultiTargetLogRecordProcessor_config, "f").flushConfig,
                    errorHandler: __classPrivateFieldGet(this, _MultiTargetLogRecordProcessor_config, "f").errorHandler,
                });
            });
            return undefined;
        });
    }
    forceFlush() {
        if (__classPrivateFieldGet(this, _MultiTargetLogRecordProcessor_isShutdown, "f")) {
            return Promise.reject(new Error('Processor has been shutdown'));
        }
        return __classPrivateFieldGet(this, _MultiTargetLogRecordProcessor_instances, "m", _MultiTargetLogRecordProcessor_flushAll).call(this);
    }
    onEmit(logRecord) {
        if (__classPrivateFieldGet(this, _MultiTargetLogRecordProcessor_isShutdown, "f")) {
            return;
        }
        if (__classPrivateFieldGet(this, _MultiTargetLogRecordProcessor_config, "f").skipCache) {
            __classPrivateFieldGet(this, _MultiTargetLogRecordProcessor_instances, "m", _MultiTargetLogRecordProcessor_export).call(this, [logRecord]);
        }
        else {
            __classPrivateFieldGet(this, _MultiTargetLogRecordProcessor_instances, "m", _MultiTargetLogRecordProcessor_pushToQueue).call(this, logRecord);
        }
    }
    async shutdown() {
        if (__classPrivateFieldGet(this, _MultiTargetLogRecordProcessor_isShutdown, "f")) {
            return;
        }
        await __classPrivateFieldGet(this, _MultiTargetLogRecordProcessor_instances, "m", _MultiTargetLogRecordProcessor_flushAll).call(this);
        await Promise.all(Object.values(__classPrivateFieldGet(this, _MultiTargetLogRecordProcessor_queues, "f")).map(queue => queue.shutdown()));
        __classPrivateFieldSet(this, _MultiTargetLogRecordProcessor_isShutdown, true, "f");
    }
}
_MultiTargetLogRecordProcessor_config = new WeakMap(), _MultiTargetLogRecordProcessor_isShutdown = new WeakMap(), _MultiTargetLogRecordProcessor_queues = new WeakMap(), _MultiTargetLogRecordProcessor_instances = new WeakSet(), _MultiTargetLogRecordProcessor_export = async function _MultiTargetLogRecordProcessor_export(logRecords) {
    await Promise.all(logRecords.map(async (logRecord) => {
        const exporterTarget = __classPrivateFieldGet(this, _MultiTargetLogRecordProcessor_config, "f").exporterTargets[logRecord.severityNumber || SeverityNumber.UNSPECIFIED] ||
            __classPrivateFieldGet(this, _MultiTargetLogRecordProcessor_config, "f").exporterTargets[SeverityNumber.UNSPECIFIED];
        if (Array.isArray(exporterTarget)) {
            await Promise.all(exporterTarget.map(e => exportCommon(__classPrivateFieldGet(this, _MultiTargetLogRecordProcessor_config, "f").exporters[e], [logRecord])));
        }
        else {
            await exportCommon(__classPrivateFieldGet(this, _MultiTargetLogRecordProcessor_config, "f").exporters[exporterTarget], [
                logRecord,
            ]);
        }
    }));
}, _MultiTargetLogRecordProcessor_pushToQueue = function _MultiTargetLogRecordProcessor_pushToQueue(logRecord) {
    const exportTarget = __classPrivateFieldGet(this, _MultiTargetLogRecordProcessor_config, "f").exporterTargets[logRecord.severityNumber]
        || __classPrivateFieldGet(this, _MultiTargetLogRecordProcessor_config, "f").exporterTargets[SeverityNumber.UNSPECIFIED];
    if (Array.isArray(exportTarget)) {
        exportTarget.forEach(target => {
            __classPrivateFieldGet(this, _MultiTargetLogRecordProcessor_queues, "f")[target].push(logRecord);
        });
    }
    else {
        __classPrivateFieldGet(this, _MultiTargetLogRecordProcessor_queues, "f")[exportTarget].push(logRecord);
    }
}, _MultiTargetLogRecordProcessor_flushAll = async function _MultiTargetLogRecordProcessor_flushAll() {
    await Promise.all(Object.values(__classPrivateFieldGet(this, _MultiTargetLogRecordProcessor_queues, "f")).map(queue => queue.flush()));
};
//# sourceMappingURL=multi-target-processor.js.map